/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2022-12-27 11:23:53
 * @LastEditors: ywj@originqc.com
 * @LastEditTime: 2024-12-20 17:33:47
 * @LastEditors: zjy
 * @LastEditTime: 2023-07-27 15:57:41
 * @FilePath: \qcloud-web-pc-4.0\src\locale\lang\en.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import login from '../../views/Login/lang/en'
import home from '@/views/home/lang/en'


import header from '@/components/page-header/lang/en';
import footer from '@/components/page-footer/lang/en';
// import computing from '@/views/computing/lang/en';
import documentTitle from '@/router/lang/en';
import paginateCommon from '@/components/pagination-common/lang/en';

import errorBoundary from '@/components/error-boundary/lang/en';
// import page_footer from '@/views/footer/lang/cn';

const enUS = {
  login,
  home,
  header,
  footer,
  documentTitle,
  paginateCommon,
  errorBoundary,
  // page_footer
}
export default enUS
